import { render, staticRenderFns } from "./SettingsToggler.vue?vue&type=template&id=e6247f3e&scoped=true&lang=pug&"
import script from "./SettingsToggler.vue?vue&type=script&lang=js&"
export * from "./SettingsToggler.vue?vue&type=script&lang=js&"
import style0 from "./SettingsToggler.vue?vue&type=style&index=0&id=e6247f3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6247f3e",
  null
  
)

export default component.exports